<template>
  <div class="headers" id="indexHeader">
    <div class="containerBox">
      <div
        class="header flex align-items"
        style="justify-content: space-between"
      >
        <div class="left flex align-items" style="cursor: pointer">
          <img
            class="img"
            :src="
              scrollState
                ? require('../assets/img/sssssssss/logoNew.png')
                : require('../assets/img/sssssssss/logoNewWhite.png')
            "
            alt=""
          />
        </div>
        <div class="right flex align-items">
          <nav class="nav" id="navItemTextColor">
            <template v-for="(item, index) in navList">
              <div
                v-if="!item.hidden"
                @mouseenter="handleMouseEnter(index)"
                class="nav-itemBox"
                @mouseleave="handleMouseLeave(index)"
                :key="item.id"
              >
                <router-link
                  v-if="item.id !== 8"
                  :to="{ path: item.path !== '/information' ? item.path : '' }"
                  :target="item.target"
                  class="nav-item"
                  :class="{ active: scrollState && index === 0 }"
                  :style="{
                    fontWeight: scrollState
                      ? 'normal'
                      : index === 0
                      ? 'bold'
                      : 'normal',
                  }"
                >
                  <div
                    v-if="item.id === 9"
                    @click.prevent.stop="handleLCMTitleClick"
                    :style="{ color: scrollState ? '#00161A' : '#fff' }"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    v-else
                    :style="{ color: scrollState ? '#00161A' : '#fff' }"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="childNavMeun"
                    v-show="
                      item.children && item.children.length > 0 && item.show
                    "
                    :style="{
                      backgroundColor: !scrollState
                        ? 'rgba(0, 0, 0, 0.21)'
                        : '#fff',
                    }"
                  >
                    <div
                      class="childNavMeunList"
                      v-for="items in item.children"
                      :key="items.id"
                    >
                      <router-link
                        v-if="index == 2 || index == 3"
                        :style="{
                          color: !scrollState ? '' : '#333 !important',
                        }"
                        class="childNavMeunLink"
                        :to="{ path: items.path }"
                        >{{ items.name }}</router-link
                      >
                      <a
                        v-else-if="index === 9"
                        :style="{
                          color: !scrollState ? '' : '#333 !important',
                        }"
                        class="childNavMeunLink"
                        href="javascript:;"
                        @click.prevent="handleLCMClick(items)"
                        >{{ items.name }}</a
                      >

                      <router-link
                        v-else
                        :style="{
                          color: !scrollState ? '' : '#333 !important',
                        }"
                        class="childNavMeunLink"
                        :to="{ path: items.path }"
                        >{{ items.name }}</router-link
                      >
                    </div>
                  </div>
                </router-link>
                <a
                  v-else
                  @click="handleLDesignClick(item)"
                  class="nav-item"
                  style="cursor: pointer"
                >
                  <div :style="{ color: scrollState ? '#00161A' : '#fff' }">
                    {{ item.name }}
                  </div>
                </a>
              </div>
            </template>
          </nav>
          <login-menu :scrollState="scrollState" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginMenu from "@/components/login-menu";
import { videoClassifyList } from "@/api/lx";
import { getLDesignPlatformUrl, getLCMPlatformUrl } from "@/api/apis";
export default {
  components: {
    loginMenu,
  },
  data() {
    return {
      navList: [
        { id: 1, name: "首页", path: "/" },
        {
          id: 2,
          name: "资料获取",
          path: "/information",
          show: false,
          children: [
            { id: 9, name: "产品手册", path: "/information/productManual" },
            // { id: 10, name: "解决方案", path: "/information/solution" },
            // { id: 11, name: "市场业绩", path: "/information/achievement" },
            { id: 12, name: "软件及工具", path: "/information/tool" },
          ],
        },
        {
          id: 3,
          name: "培训学院",
          path: "/school/index",
          show: false,
          children: [],
        },
        {
          id: 13,
          name: "新闻中心",
          path: "/news/index?id=1",
          show: false,
          children: [
            { id: 1, name: "新闻资讯", path: "/news/index?id=1" },
            { id: 2, name: "产品公告", path: "/news/index?id=2" },
          ],
        },
        { id: 4, name: "服务权益", path: "/service/index" },
        { id: 5, name: "社区联盟", path: "/community/index" },
        { id: 6, name: "常见问题", path: "/forum/index" },
        { id: 7, name: "积分商城", path: "/shop/index", hidden: true },
        {
          id: 8,
          name: "L-Design平台",
          path: "http://101.245.69.18:81/index.html#/login?redirect=drawingDownload",
        },
        {
          id: 9,
          name: "LCM平台",
          show: false,
          children: [
            { id: 0, name: "项目查重", path: "/project/check" },
            { id: 1, name: "项目新建", path: "/project/create" },
            { id: 2, name: "项目管理", path: "/project/manage" },
          ],
        },
        {
          id: 10,
          name: "LWS良仓",
          path: "/lws/index",
        },
      ],
      scrollState: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getVideoClassifyList();
  },
  methods: {
    getVideoClassifyList() {
      // videoClassifyList({}).then((res) => {
      //   res.data.map((ele) => {
      //     ele.path = "/school/index?id=" + ele.id;
      //   });
      //   this.navList[2].children = res.data;
      // });
    },
    // 鼠标移入方法
    handleMouseEnter(index) {
      const dropdownIndexes = [1, 2, 3, 9];
      if (dropdownIndexes.includes(index)) {
        dropdownIndexes.forEach((i) => {
          this.navList[i].show = false;
        });
        this.navList[index].show = true;
      }
    },
    handleMouseLeave() {
      [1, 2, 3, 9].forEach((i) => {
        this.navList[i].show = false;
      });
    },
    // 鼠标移出方法
    handleScroll() {
      // 当页面滚动到一定高度时显示返回顶部按钮
      const showButton = window.scrollY > 80; // 例如，滚动超过80px
      const indexHeaderStyle = document.getElementById("indexHeader");
      indexHeaderStyle.style.backgroundColor = showButton
        ? "#fff"
        : "rgba(0, 0, 0, 0.2)";
      this.scrollState = showButton;
    },
    // 处理L-Design平台点击
    handleLDesignClick(item) {
      getLDesignPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            window.open(res.data.url, "_blank");
          } else {
            this.$message.error("获取L-Design平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取L-Design平台地址失败:", error);
          this.$message.error("获取L-Design平台地址失败");
        });
    },
    // 处理LCM平台点击
    handleLCMClick(items) {
      const type = items.id;
      getLCMPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            window.open(res.data[items.id].url, "_blank");
          } else {
            this.$message.error("获取LCM平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取LCM平台地址失败:", error);
          this.$message.error("获取LCM平台地址失败");
        });
    },
    // 处理LCM平台大标题点击，跳转到第四个链接（下标是3）
    handleLCMTitleClick() {
      getLCMPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            if (res.data[3] && res.data[3].url) {
              window.open(res.data[3].url, "_blank");
            } else {
              this.$message.error("获取LCM平台主地址失败");
            }
          } else {
            this.$message.error("获取LCM平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取LCM平台地址失败:", error);
          this.$message.error("获取LCM平台地址失败");
        });
    },
  },
};
</script>

<style scoped lang="less">
.containerBox {
  width: 1800px;
  margin: 0 auto;
}
.headers {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  .img {
    height: 36px;
    // width: 130px;
  }
}
.nav {
  display: flex;
  align-items: center;
  margin-right: 50px;
  .nav-itemBox {
    padding: 0 25px;
    .nav-item {
      position: relative;
      text-align: center;
      display: block;
      color: #fff;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      line-height: 74px;
      font-size: 18px;
      h3 {
        font-size: 16px;
      }
    }
    .active div {
      color: #00d8c3 !important;
    }
  }
}
.childNavMeun {
  position: absolute;
  top: 74px;
  left: -51px;
  background-color: rgba(0, 0, 0, 0.21);
  width: 175px;
  padding: 5px 0;
  z-index: 999;
  .childNavMeunList {
    line-height: 40px !important;
    .childNavMeunLink {
      cursor: pointer;
      font-size: 16px;
      color: #fff;
      text-decoration: none;
    }
  }
}

/deep/.header-custom-btn {
  color: #2e3033;
  border-color: transparent;
  background-color: transparent;
  a {
    color: initial;
    text-decoration: none;
  }
}

/deep/.user-info {
  .el-dropdown-link {
    color: #2e3033;
    cursor: pointer;
  }
}
</style>

